import QiXinCorpSearch from './QiXinCorpSearch';

export default QiXinCorpSearch;
